//mui
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

// MUI Icons
import { ReactComponent as FacebookIcon } from "../../../assets/facebook_icon.svg";
import { ReactComponent as InstagramIcon } from "../../../assets/instagram_icon.svg";
import { ReactComponent as YoutubeIcon } from "../../../assets/youtube.svg";

//components
import CustomPopperCheckbox from "./PopperComponentCheckbox";

const Container = styled("div")(({ theme, fontSize, Type }) => ({
  "& .MuiAutocomplete-root": {
    background: "#FFFFFF",
  },
  "& .MuiAutocomplete-input": {
    height: "19px",
    fontSize: "14px",
    [theme.breakpoints.down("xl")]: {
      height: "17px",
      fontSize: "14px",
    },
  },
  "& .MuiInputBase-root": {
    padding: 0,
  },
  "& .MuiInputLabel-root": {
    paddingBottom: "30px",
    fontSize: "15px",
    color: "#4F4F4F",
    [theme.breakpoints.down("xl")]: {
      fontSize: "14px",
    },
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
    // paddingTop: "3px",
    // paddingBottom: "3px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    "& .MuiChip-root": {
      margin: Type === 2 ? "0px" : theme.spacing(0.5),
      marginRight: "5px",
    },
    "& .MuiChip-label": {
      fontSize: `${fontSize || "12px"} !important`,
      paddingTop: 0,
      paddingBottom: 0,
      [theme.breakpoints.down("xl")]: {
        fontSize: "11px",
      },
    },
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
      [theme.breakpoints.down("xl")]: {
        fontSize: "16px",
      },
    },
    "& .MuiAutocomplete-tagSizeMedium": {
      fontSize: "14px",
      // background: "cyan",
      [theme.breakpoints.down("xl")]: {
        fontSize: "12px",
      },
    },
  },
  "& .MuiAutocomplete-root .MuiAutocomplete-tag": {
    height: "28px",
    padding: 0,
    [theme.breakpoints.down("xl")]: {
      height: "26px",
    },
  },
}));

const StyledCheckbox = styled(Checkbox)({
  marginRight: "2px",
});

const IconWrapper = styled("span")({
  marginRight: "8px",
  display: "flex",
  alignItems: "center",
});

const OptionListItem = styled("li")(({ fontSize }) => ({
  fontSize: fontSize,
}));

const PlatformIcon = styled("div")({
  height: 18,
  width: 18,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& svg": {
    width: "100%",
    height: "100%",
  },
});

const icon = (
  <CheckBoxOutlineBlankIcon fontSize="small" sx={{ margin: 0, padding: 0 }} />
);
const checkedIcon = <CheckBoxIcon fontSize="small" color="secondary" />;

const platforms = [
  {
    id: 3,
    label: "Facebook",
    value: "facebook",
    icon: <FacebookIcon style={{ height: 18, width: 18 }} />,
  },
  {
    id: 1,
    label: "Instagram",
    value: "instagram",
    icon: <InstagramIcon style={{ height: 18, width: 18 }} />,
  },
  {
    id: 2,
    label: "YouTube",
    value: "youtube",
    icon: <YoutubeIcon style={{ height: 18, width: 18 }} />,
  },
];

const AutoCompleteMultiPlatformSelect = ({
  isSingleSelect = false,
  options = platforms,
  value,
  variant = "outlined",
  onChange,
  disabled = false,
  label,
  limitTags,
  text,
  onInputChange,
  currentPage,
  pageCount,
  loadType,
  getUsersData,
  project,
  property,
  leftIcon,
  fontSize,
  Type = 1,
  popupIcon,
  Outsidelabel = null,
  className = "",
  ...restProps
}) => {
  return (
    <Container fontSize={fontSize} Type={Type} className={className}>
      {Outsidelabel}
      <FormControl variant="outlined" sx={{ width: "100%", padding: 0 }}>
        <Autocomplete
          multiple={!isSingleSelect}
          disableCloseOnSelect={!isSingleSelect}
          fullWidth
          options={options || []}
          value={value}
          onInputChange={onInputChange}
          getOptionLabel={(option) => option?.label || ""}
          isOptionEqualToValue={(option, value) =>
            option?.value === value?.value
          }
          popupIcon={popupIcon}
          onChange={(event, newValue) => {
            onChange(newValue, text);
          }}
          renderOption={
            isSingleSelect
              ? undefined
              : (props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps} style={{ fontSize }}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: "2px" }}
                        checked={selected}
                      />
                      {option.icon && (
                        <span
                          style={{
                            marginRight: "8px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {option.icon}
                        </span>
                      )}
                      {option.label}
                    </li>
                  );
                }
          }
          renderTags={
            isSingleSelect
              ? undefined
              : (value, getTagProps) => {
                  if (Type === 1) {
                    return value.length > 1 ? (
                      <Chip
                        label={`${value[0].label.substring(0, 17)}${
                          value[0].label.length > 17 ? "..." : ""
                        } + ${value.length - 1}`}
                        {...getTagProps(0)}
                      />
                    ) : (
                      <Chip label={value[0].label} {...getTagProps(0)} />
                    );
                  } else if (Type === 2) {
                    return value.map((v, index) => (
                      <Chip
                        label={v.label}
                        {...getTagProps({ index })}
                        icon={v.icon}
                      />
                    ));
                  }
                }
          }
          renderInput={(params) => {
            const { InputProps, inputProps, ...renderProps } = params;
            inputProps.disabled = disabled;

            // Add icon for single select
            const selectedOption = isSingleSelect && value ? value : null;

            return (
              <TextField
                {...renderProps}
                InputProps={{
                  ...InputProps,
                  startAdornment: selectedOption?.icon ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginRight: "8px",
                      }}
                    >
                      {selectedOption.icon}
                    </span>
                  ) : (
                    InputProps.startAdornment
                  ),
                }}
                inputProps={inputProps}
                label={label}
                variant={variant}
                {...restProps}
              />
            );
          }}
          PopperComponent={disabled ? () => null : CustomPopperCheckbox}
        />
      </FormControl>
    </Container>
  );
};

export default AutoCompleteMultiPlatformSelect;
